import { Component, OnInit } from '@angular/core';
import { MasterDataService } from '../../services/master-data.service';
import { NgModel } from '@angular/forms';
import * as moment from 'moment';
import * as html2pdf from 'html2pdf.js';
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { CommonMessageService } from 'src/app/services/common-message.service';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Component({
  selector: 'app-overtime-report',
  templateUrl: './overtime-report.component.html',
  styleUrls: ['./overtime-report.component.css']
})
export class OvertimeReportComponent implements OnInit {

  financialList;
  selectedFinancialYear;
  closingDateList;
  selectedFromClosing;
  selectedToClosing;
  isPartnerSelected = false;
  selectedEmployeeStatus;
  selectedEmployee;
  selectedPartner;
  partnerList;
  employeeList;
  overTimeReportList;
  totalOtAmmount;
  totalInHours;

  constructor(private masterDataService: MasterDataService,private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.selectedFinancialYear = '';
    this.selectedFromClosing = '';
    this.selectedToClosing = '';
    this.selectedEmployeeStatus = '1';
    this.loadInitialDetails();
  }

  loadInitialDetails() {
    this.masterDataService.getFinancialYear().subscribe((res) => {
      this.financialList = res;
    });

    this.masterDataService.getPartners().subscribe((res) => {
      this.partnerList = res;
      console.log('Partner list', this.partnerList);
    })
  }

  onFinancialYearSelected() {
    if (
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFinancialYear != ''
    ) {
      this.masterDataService
        .getClosingDatesByFinancialYear(this.selectedFinancialYear.id)
        .subscribe((res) => {
          this.closingDateList = res;
          console.log('closing date list', this.closingDateList);
        });
    }
    this.selectedFromClosing = '';
    this.selectedToClosing = '';
  }


  // getUserByPrtner
  onPartnerSelected() {
    if (
      this.selectedFinancialYear != '' &&
      this.selectedFinancialYear != null &&
      this.selectedFinancialYear != undefined &&
      this.selectedFromClosing != '' &&
      this.selectedFromClosing != null &&
      this.selectedFromClosing != undefined &&
      this.selectedToClosing != '' &&
      this.selectedToClosing != null &&
      this.selectedToClosing != undefined
    ) {
      this.employeeList = [];

      console.log('inside partner method', this.selectedPartner);

      console.log('inside partner method', this.selectedEmployeeStatus);
      var partnerId = this.selectedPartner.map(({ id }) => id);
      console.log('partner id array', partnerId);
      if (this.selectedPartner[0] != 0 && partnerId.length != 0) {
        this.masterDataService.getUserByPrtner(partnerId, this.selectedEmployeeStatus).subscribe((res) => {
          console.log('employee List', res);
          this.employeeList = res;
        });
      }
    }
  }

  selectAllPartner(select: NgModel, values) {
    this.employeeList = [];
    this.selectedPartner = values;

    this.selectAll(select, values, this.isPartnerSelected);
    this.isPartnerSelected = !this.isPartnerSelected;
    this.onPartnerSelected();
  }

  selectAllEmployee(select: NgModel, values) {
    this.selectAll(select, values, this.isPartnerSelected);
    this.isPartnerSelected = !this.isPartnerSelected;
  }

  selectAll(select: NgModel, values, isSelected) {
    if (!isSelected) {
      select.update.emit(values);
    } else select.update.emit([]);
  }

  showButton: boolean;
  userId;
  onViewReport() {
    if (
      this.selectedFinancialYear == null ||
      this.selectedFinancialYear == undefined ||
      this.selectedFinancialYear == '' ||
      this.selectedFromClosing == null ||
      this.selectedFromClosing == '' ||
      this.selectedToClosing == null ||
      this.selectedToClosing == '' ||
      this.selectedPartner == null ||
      this.selectedPartner.length === 0 ||
      this.selectedEmployee == null ||
      this.selectedEmployee.length === 0
    ) {
      this.commonMessageService.swalAlertWithoutIcon('','Please choose all the values');
      return;
    }
    this.userId = this.selectedEmployee.map(({ id }) => id);
    this.masterDataService.getOverTimeReport(this.selectedFromClosing.id, this.selectedToClosing.id, this.userId)
      .subscribe((res: any) => {
        console.log('overTime report details', res);
        this.overTimeReportList = res;
        if (this.overTimeReportList != null && this.overTimeReportList.length > 0) {
          this.showButton = true;
        } else {
          this.commonMessageService.swalAlertWithoutIcon('','No Record Found');
          this.showButton = false;
        }
      });
  }

  changeMonthNumberToName(month) {
    return moment(month, 'M').format('MMMM');
  }


  getTotalInHours(data) {
    this.totalInHours = 0;
    data.details.map((res: any) => {
      this.totalInHours += res.otHrs;
    });
    return this.totalInHours;
  }

  getTotalOtAmmount(data) {
    this.totalOtAmmount = 0;
    data.details.map((res: any) => {
      this.totalOtAmmount += res.otAmmount;
    });
    return this.totalOtAmmount;
  }

  exportToExcelClick() {
    this.masterDataService.getOverTimeReportExcel(this.selectedFromClosing.id, this.selectedToClosing.id, this.userId)
      .subscribe((resp: any) => {
        const blob = new Blob([resp]); // you can change the type
        var downloadURL = window.URL.createObjectURL(blob);
        var link = document.createElement('a');
        link.href = downloadURL;
        link.download = "OverTimeReport.xlsx";
        link.click();
      });
  }

  exportToPDFClick() {
    var docDefinition = {
      info: { title: 'OverTime Report' },
      pageOrientation: 'landscape',
      content: [
      ],
    };

    docDefinition.content.push({ text: 'P G BHAGWAT LLP, Chartered Accountants', fontSize: 14, bold: true, alignment: 'center' });
    docDefinition.content.push({ text: 'Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045', alignment: 'center' });
    docDefinition.content.push({ text: 'OverTime Report', fontSize: 14, bold: true, alignment: 'center', margin: [0, 10, 0, 5] });
    for (let i = 0; i < this.overTimeReportList.length; i++) {
      var totalOTHrs = 0;
      var totalOTAmt = 0;
      this.overTimeReportList[i].details.map(res => {
        totalOTHrs = totalOTHrs + res.otHrs;
        totalOTAmt = totalOTAmt + res.otAmmount;
      });
      docDefinition.content.push(' ');
      docDefinition.content.push({ text: `Employee Name:${this.overTimeReportList[i].firstName} ${this.overTimeReportList[i].lastName}`, fontSize: 12, bold: true, margin: [0, 0, 0, 5] })
      docDefinition.content.push({
        table: {
          headerRows: 1,
          widths: ['*', '*', '*'],
          body: [
            [{ text: 'Month Of OverTime', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'OverTime In Hours', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }, { text: 'Amount Paid', fillColor: '#17a2b8 !important', color: 'white', margin: [0, 5, 0, 5] }],
            ...this.overTimeReportList[i].details.map(res => [{ text: `${this.changeMonthNumberToName(res.month)}/${res.year}` }, { text: res.otHrs }, { text: res.otAmmount }]),
            [{ text: 'Total', bold: true, fillColor: '#e1f4f7' }, {
              text: `${totalOTHrs}`, fillColor: '#e1f4f7'
            }, { text: `${totalOTAmt}`, fillColor: '#e1f4f7' }]
          ]
        }
      }
      );
    }
    pdfMake.createPdf(docDefinition).download('OverTimeReport.pdf');
  }
}


